import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient.js';
import { type JobScope } from 'api/queries/useLaundroworksCustomerSyncJobs';

export interface ActiveJob {
  jobId: string;
  businessId: number;
  scope: JobScope;
  state: string;
}

interface ActiveJobsResponse {
  exist: boolean;
  jobs?: ActiveJob[];
}

export const getLaundroworksActiveJobs = (businessId: number): AxiosPromise<ActiveJobsResponse> => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/laundroworks/customer-sync/active-jobs`,
    params: { businessId },
  });
};
export const getLaundryCatActiveJobs = (businessId: number): AxiosPromise<ActiveJobsResponse> => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/laundrycat/customer-sync/active-jobs`,
    params: { businessId },
  });
};
